import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  ConstructionSite,
  ConstructionSiteState,
} from 'projects/shared/src/public-api';

@Component({
  selector: 'lib-construction-site-picker',
  templateUrl: './construction-site-picker.component.html',
  styleUrls: ['./construction-site-picker.component.scss'],
  standalone: false,
})
export class ConstructionSitePickerComponent implements OnInit {
  constructor() {}

  @Input()
  preselectedConSite: string;
  @Input()
  conSites: Observable<ConstructionSite[]>;
  @Input()
  multiple: boolean;
  @Input()
  showAllEntry: boolean;
  @Output()
  selectedConSiteChanged: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  blackList: string[];
  allEntry: ConstructionSite = { name: 'Alle Baustellen' };

  selectedConSite: string;
  activeConSites$: Observable<ConstructionSite[]>;
  popoverOptions = {
    cssClass: 'custom-select-popover',
  };

  ngOnInit() {
    if (this.conSites) {
      this.activeConSites$ = this.conSites.pipe(
        map((sites) =>
          sites?.filter(
            (site) =>
              site.state == ConstructionSiteState.$0 ||
              site.id == this.preselectedConSite
          )
        )
      );
    }
  }

  getPreselectedConstructionSite(): Observable<ConstructionSite> {
    return this.conSites.pipe(
      map((x) => {
        if (this.showAllEntry) return this.allEntry;
        return x?.length == 1 ? x[0] : null;
      })
    );
  }
  handleClick(id: string) {
    this.selectedConSite = id;
    this.selectedConSiteChanged.emit(id);
  }
}
